import React, { Component } from 'react';
import {
  Form,
} from 'semantic-ui-react';

class Socials extends Component {
  render() {
    const {
      coRenter,
      coRenterSsn,
      renter,
      renterSsn,
    } = this.props;

    return (
      <div style={{
        padding: '25px 0',
        borderBottom: '1px solid #eee'
      }}
        data-private
      >
        <h2>Social Security Numbers</h2>
        <p>
          Social security numbers are not saved on our server and are used for creating a PDF copy of this contract.
        </p>
        <Form size="large">
          <Form.Input
            label={`${renter} Social Security Number (No dashes, no slashes, numbers only)`}
            required
            placeholder="ex: 123456789"
            value={renterSsn}
            name="renterSsn"
            onChange={(e) => (
              !isNaN(e.target.value) &&
              e.target.value.length <= 9
                ? this.props.onChange(e)
                : null
            )}
          />
          {
            this.props.coRenter
              ? (
                  <Form.Input
                    label={`${coRenter} Social Security Number (No dashes, no slashes, numbers only)`}
                    required
                    placeholder="ex: 123456780"
                    value={coRenterSsn}
                    name="coRenterSsn"
                    // onChange={this.props.onChange}
                    onChange={(e) => (
                      !isNaN(e.target.value) &&
                      e.target.value.length <= 9
                        ? this.props.onChange(e)
                        : null
                    )}
                  />
                )
              : null
          }
        </Form>
      </div>
    );
  }
}

export default Socials;

